import { IRequestCommand } from 'app/services/authentication/connection/iRequestCommand';
import { ICarrierBranchResponseDTO, ErrorDetails } from 'app/services/authentication/connection/interfaces/apiInterfaces';
import { CommandRequestType } from 'app/services/authentication/connection/commandRequestType';
import { ICommandParameters } from 'app/services/authentication/connection/iCommandParameters';
import { ICommandResponse } from 'app/services/authentication/connection/iCommandResponse';

export class CreateCarrierBranchV2Command extends IRequestCommand<
  ICommandResponse,
  ErrorDetails,
  CreateCarrierBranchV2CommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.PUT;
  override _commandUrl = 'carriers/{carrierId}/branch';

  public override setParameters(parameters: CreateCarrierBranchV2CommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierId}',
      parameters.carrierId ? parameters.carrierId.toString() : ''
    );
    this._commandBody = parameters;
  }
}

export interface CreateCarrierBranchV2CommandParameters
  extends ICarrierBranchResponseDTO,
    ICommandParameters {
  carrierId?: string;
}
